<template lang="pug">
  div.col-xl-4.col-lg-6.col-md-6.col-sm-6
    div.col-gcc
      div.card-personal-detail
        .cardInfo.text-right  External Card
        el-input(type="text",v-model='item.nameOnCardByUser',placeholder="Enter Name on Card")
        .card-information.mb-2(v-if="!item.nameOnCardByUser") Enter Name on Card
        el-input(type="text",v-model='item.last_four',placeholder="last Four of Card")
        .card-information.mb-2(v-if="!item.last_four") last Four of Card
        el-select(
            filterable
            v-model="item.expireMonth"
            placeholder="MM",
            @change = 'changeMonth'
          ).dropdown-select.change-month
            el-option(
              v-for='item in months'
              :key="item.id"
              :label="item.name"
              :value="item.name"
            )
        el-select(
            filterable
            v-model="item.expireYear"
            placeholder="YYYY",
            @change = 'changeYear'
          ).dropdown-select.change-year
            el-option(
              v-for='item in years'
              :key="item.id"
              :label="item.name"
              :value="item.name"
            )
        .card-information.mb-2(
          v-if="!item.expireMonth || !item.expireYear"
        ) Enter expire month and year
        .small-text(v-if="this.item.isDuplicate")
          i.el-icon-error This card is already exist in Other Company

        el-button(type='success' round @click='submitCardDetails') Submit
        //- el-button(type='danger' round) danger
      el-form(
        ref='item'
        :v-model='item'
        :key='item.id'
        label-width='100px'
        :rules='rules',
      )
        div.ecc-row
          div.eccAccNO
            label Employee Name
            div.eccACvalue {{ getName(item.user) }}
              el-button(
                type='text'
                icon='el-icon-edit'
                @click.stop='handleShowListEmployee'
              ).text-secondary.px-1
              el-form-item(prop="user").dropUserList
                el-select(
                  v-if="showEmployeeList"
                  v-model='item.user',
                  value-key='id',
                  filterable,
                  placeholder='Select employee name',
                  v-on:change='handleEmployeeChange($event)'
                )
                  el-option(
                    v-for='item in getUserWithGrList',
                    :key='item.id',
                    :label='getName(item)',
                    :value='item'
                  )
        div.ecc-row
          div.eccAccNO
            label Company
            div.eccACvalue {{ companyName }}

        div.ecc-row
          div.eccAccNO
            label(v-if='item.lastFourType') Account Number
            label(v-else)  Card Number
            div.eccACvalue XXXX &nbsp; XXXX &nbsp; XXXX &nbsp; {{getLastFour(item.last_four)}}
        div.ecc-row.mb-1
          div.row
            div.col-md-5.security-code.mb-0
              div.eccCVV
                label Security Code
                div.eccvalue XXX
            div.col-md-4.valid-thru.mb-0
              div.eccCVT
                label Valid Thru
                div.eccvalue XX/XX
        div.ecc-row.mb-0
          div.eccACvalue
            P
              | Include Transactions:
            span(v-if='item.isSyncWithMainTable')
              | Yes
            span(v-else)
              | No
            el-switch(
              active-color="#4c9261"
              inactive-color="#FF9292"
              @change="switchOn"
              v-model='item.isSyncWithMainTable'
            )

        el-button(
          v-if='showSaveButton'
          type='primary',
          @click='validateForm(item)',
        ).btnCC-save.mt-2 Save

</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'ExtranalCreditCardMgmt',
  props: {
    item: {
      default: () => {
        // this is default
      },
      type: Object,
    },
    companyName: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      isErrorDuplicte: false,
      nameOnCard: null,
      mm: null,
      yyyy: null,
      months: [
        { id: 0, name: '01' },
        { id: 1, name: '02' },
        { id: 2, name: '03' },
        { id: 3, name: '04' },
        { id: 4, name: '05' },
        { id: 5, name: '06' },
        { id: 6, name: '07' },
        { id: 7, name: '08' },
        { id: 8, name: '09' },
        { id: 9, name: '10' },
        { id: 10, name: '11' },
        { id: 11, name: '12' },
      ],
      years: [],
      showSaveButton: false,
      showEmployeeList: false,
      showNameField: false,
      userFriendlyName: '',
      last_four: '',
      user: '',
      rules: {
        user: {
          required: true,
          message: 'Please enter address',
          trigger: 'blur',
        },
      },
    };
  },

  computed: {
    ...mapGetters('users', ['getUserWithGrList']),
    ...mapGetters('eCCTransactions', ['setExtCardName']),
  },

  watch: {
    setExtCardName(value) {
      if (value.error) {
        if (this.item.id === value.id) {
          this.item.isDuplicate = true;
        }
      }
      if (value.text) {
        if (this.item.id === value.id) {
          this.$message({
            message: 'Card details updated.',
            type: 'success',
          });
          this.item.isDuplicate = false;
        }
      }
    },
  },

  created() {
    this.getyears();
  },

  methods: {
    ...mapActions('eCCTransactions', ['mapExternalCCToUser', 'setCardName']),
    getLastFour(value) {
      if (value === 'XXXX' || value === '' || value === null) {
        return 'XXXX';
      }
      return value;
    },
    changeMonth() {
      // future implementatation
    },
    changeYear() {
      // future implementatation
    },
    switchOn() {
      if (this.item.last_four === null || this.item.last_four === '') {
        this.item.isSyncWithMainTable = false;
        this.$message({
          message: 'Please enter required card information.',
          type: 'error',
        });
        return;
      }

      if (this.item.last_four) {
        if (isNaN(this.item.last_four)) {
          this.item.isSyncWithMainTable = false;
          this.$message({
            message: 'Please enter numeric value in card details.',
            type: 'error',
          });
          return;
        }
      }

      if (this.item.nameOnCardByUser === null || this.item.nameOnCardByUser === '') {
        this.item.isSyncWithMainTable = false;
        this.$message({
          message: 'Please enter card\'s owner name..',
          type: 'error',
        });
        return;
      }

      if (this.item.expireMonth === null) {
        this.item.isSyncWithMainTable = false;
        this.$message({
          message: 'Please enter expiry date month.',
          type: 'error',
        });
        return;
      }

      if (this.item.expireYear === null) {
        this.item.isSyncWithMainTable = false;
        this.$message({
          message: 'Please enter expiry date year.',
          type: 'error',
        });
      }
    },

    submitCardDetails() {
      if (this.item.last_four === null || this.item.last_four === '') {
        this.item.isSyncWithMainTable = false;
        this.$message({
          message: 'Please enter required card information.',
          type: 'error',
        });
        return;
      }

      if (this.item.last_four) {
        if (isNaN(this.item.last_four)) {
          this.item.isSyncWithMainTable = false;
          this.$message({
            message: 'Please enter numeric value in card details.',
            type: 'error',
          });
          return;
        }
      }

      if (this.item.nameOnCardByUser === null || this.item.nameOnCardByUser === '') {
        this.item.isSyncWithMainTable = false;
        this.$message({
          message: 'Please enter card\'s owner name..',
          type: 'error',
        });
        return;
      }

      if (this.item.expireMonth === null) {
        this.item.isSyncWithMainTable = false;
        this.$message({
          message: 'Please enter expiry date month.',
          type: 'error',
        });
        return;
      }

      if (this.item.expireYear === null) {
        this.item.isSyncWithMainTable = false;
        this.$message({
          message: 'Please enter expiry date year.',
          type: 'error',
        });
        return;
      }

      this.setCardName({
        itemId: this.item.itemId,
        cardId: this.item.id,
        nameOnCard: this.item.nameOnCardByUser,
        lastFour: this.item.last_four,
        expirationDate: moment(new Date(this.item.expireYear, Number(this.item.expireMonth) - 1, '01')).format('MM-DD-YYYY'),
        isSyncWithMainTable: this.item.isSyncWithMainTable,
      });
    },
    handleEmployeeChange() {
      this.showEmployeeList = false;
      this.showSaveButton = true;
    },

    clicked() {
      this.showEmployeeList = false;
    },

    handleShowListEmployee() {
      this.showEmployeeList = !this.showEmployeeList;
    },
    handleShowName() {
      this.showNameField = !this.showNameField;
    },

    validateForm(value) {
      if (value.user) {
        this.showSaveButton = false;
        this.mapExternalCCToUser(value);
      } else {
        this.$message({
          message: `Please attached a user to card ${value.last_four}`,
          type: 'error',
        });
      }
    },

    getName(value) {
      if (value) {
        return `${value.firstName} ${value.lastName}`;
      }
      return 'Employee Name';
    },
    getEmployee(value) {
      const emp = [];
      if (value) {
        value.forEach((element) => {
          emp.push({
            id: element.id,
            firstName: element.firstName,
            lastName: element.lastName,
          });
        });
      }
      return emp;
    },
    getyears() {
      let startYear = new Date().getFullYear() - 5;
      const endYear = new Date().getFullYear() + 20;
      let counter = 0;
      while (endYear >= startYear) {
        counter += 1;
        this.years.push({
          id: counter,
          name: (startYear),
        });
        startYear += 1;
      }
    },

  },

};
</script>
